// extracted by mini-css-extract-plugin
export default {"sd":"ServicesDetail_sd__HVi4h","ckDescription":"ServicesDetail_ckDescription__VCFoe"};